import type { UseQueryResult } from '@tanstack/react-query'

import type { AppSettings, ClientPackagingType } from '@fv/client-types'
import type { LocationAccessorialType } from '@fv/models'
import type {
  EquipmentAccessorialType,
  EquipmentType,
} from '@fv/models/equipment'

export interface TypeNamesProvider {
  accessorialName: (
    key: LocationAccessorialType | EquipmentAccessorialType,
  ) => string
  equipmentName: (key: EquipmentType | '') => string
  packageName: (key: ClientPackagingType | '') => string
}

export function useTypeNames(
  useAppSettings: () => UseQueryResult<AppSettings, unknown>,
): TypeNamesProvider {
  const settings = useAppSettings()
  const enums = settings.data?.enums
  const accessorialTypes = enums?.accessorialTypes
  const equipmentTypes = enums?.equipmentTypes
  const packageTypes = enums?.packagingTypeList

  return {
    accessorialName: (
      key: EquipmentAccessorialType | LocationAccessorialType,
    ) => accessorialTypes?.find(a => a.key === key)?.name ?? key,
    equipmentName: (key: EquipmentType | '') =>
      equipmentTypes?.find(e => e.key === key)?.name ?? key,
    packageName: (key: ClientPackagingType | '') =>
      packageTypes?.find(p => p.key === key)?.name ?? key,
  }
}
